import React, { useEffect, useState } from 'react';
import { Drawer, message } from 'antd';
import api from '../../api';
import ResultsTable from '../ResultsTable';

/**
 * The calls behind one number, opened in their own tab on click.
 *
 * The caller hands over a complete parameter set rather than inheriting a
 * default, because the tabs that use this count different populations: the
 * upselling tables are narrowed to upsellable calls and the reasons and
 * outcomes tables are not. A shared default would put a fraction of the
 * clicked number in the drawer on one of them.
 *
 * A new tab rather than a side panel: the drawer is already a detour from the
 * summary, and sending the reader to the call in place would lose the list
 * they are working through.
 */
export default function CallsDrawer({ drill, onClose }) {
  const [rows, setRows]       = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!drill?.params) { setRows([]); return; }
    setLoading(true);
    api.get('/api/calls', { params: drill.params })
      .then((r) => setRows(r.data.data || []))
      .catch(() => message.error('Failed to load calls.'))
      .finally(() => setLoading(false));
  }, [drill]);

  return (
    <Drawer
      title={`Top 100 — ${drill?.title ?? ''}`}
      open={!!drill}
      onClose={onClose}
      width={1100}
      destroyOnClose
    >
      <ResultsTable
        data={rows}
        loading={loading}
        onRowClick={(r) => window.open(`/calls/${r.ContactID}`, '_blank', 'noopener')}
      />
    </Drawer>
  );
}
